import { TABLE_ROW_HEIGHT } from 'constants/App';

export default {
  zIndex: {
    modal: 1500,
    tooltip: 1600,
    snackbar: 1700,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.loginFields': {
          maxWidth: 280,
        },
      },
    },

    MuiCard: {
      root: {
        overflow: null,
      },
    },
    MuiCardContent: {
      root: {
        '&:last-child': {
          paddingBottom: '16px',
        },
      },
    },
    MuiDialog: {
      paperWidthMd: {
        maxWidth: 840, // Base is 980, but too large and too far from 'sm'
      },
    },
    MuiDialogContent: {
      root: {
        paddingTop: 0,
      },
      dividers: {
        padding: 0,
      },
    },
    MuiFormLabel: {
      root: {
        whiteSpace: 'nowrap',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 42,
      },
    },
    MuiSnackbarContent: {
      root: {
        width: '340px',
      },
    },
    MuiStepper: {
      root: {
        padding: 0,
      },
    },
    MuiStepContent: {
      root: {
        paddingRight: 0,
      },
    },
    MuiTable: {
      root: {
        tableLayout: 'fixed',
      },
    },
    MuiTableRow: {
      root: {
        height: TABLE_ROW_HEIGHT,
      },
    },
    MuiTableCell: {
      root: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 14,
      },
      paddingCheckbox: {
        textOverflow: 'clip',
      },
    },
    MuiBadge: {
      badge: {
        top: 3,
        right: -10,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./containers/themes/main.js